import { render, staticRenderFns } from "./Avatar.vue?vue&type=template&id=08d1707a"
import script from "./Avatar.vue?vue&type=script&lang=js"
export * from "./Avatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08d1707a')) {
      api.createRecord('08d1707a', component.options)
    } else {
      api.reload('08d1707a', component.options)
    }
    module.hot.accept("./Avatar.vue?vue&type=template&id=08d1707a", function () {
      api.rerender('08d1707a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emc/base/Avatar.vue"
export default component.exports